(function() {
  'use strict';
  
  // MULTI-APP SAFETY FIX: Scoped namespace instead of polluting window
  if (!window.__TK_CART) {
    window.__TK_CART = {
      requestCache: new Map(),
      locks: {},  // MULTI-APP SAFETY FIX: all locks live here, no window[lockKey]
      originalFetch: window.fetch,
      fetchOverridden: false
    };
    // MULTI-APP SAFETY FIX: prevent requestCache unbounded growth
    setInterval(function() {
      if (window.__TK_CART && window.__TK_CART.requestCache && window.__TK_CART.requestCache.size > 500) {
        window.__TK_CART.requestCache.clear();
      }
    }, 10000);
  }
  if (!window.__TK_CART.locks) {
    window.__TK_CART.locks = {};
  }
  
  // MULTI-APP SAFETY FIX: Generate stable request hash from body
  function generateRequestHash(url, body) {
    if (!body) return url + '_' + Date.now();
    
    try {
      let bodyStr = '';
      if (typeof body === 'string') {
        bodyStr = body;
      } else if (body instanceof FormData) {
        // FormData to string
        const params = new URLSearchParams();
        for (const [key, value] of body.entries()) {
          params.append(key, value);
        }
        bodyStr = params.toString();
      } else {
        bodyStr = JSON.stringify(body);
      }
      
      // Simple hash function
      let hash = 0;
      for (let i = 0; i < bodyStr.length; i++) {
        hash = ((hash << 5) - hash) + bodyStr.charCodeAt(i);
        hash = hash & hash;
      }
      return url + '_' + Math.abs(hash);
    } catch (e) {
      return url + '_' + Date.now();
    }
  }
  
  // MULTI-APP SAFETY FIX: Check duplicate with 200ms threshold
  function isDuplicateRequest(requestHash) {
    const cache = window.__TK_CART.requestCache;
    if (cache.has(requestHash)) {
      const lastTime = cache.get(requestHash);
      const timeDiff = Date.now() - lastTime;
      if (timeDiff < 200) {
        return true;
      }
    }
    
    cache.set(requestHash, Date.now());
    setTimeout(() => cache.delete(requestHash), 500);
    return false;
  }
  
  // MULTI-APP SAFETY FIX: Idempotent fetch override
  if (!window.__TK_CART.fetchOverridden) {
    window.__TK_CART.fetchOverridden = true;
    const originalFetch = window.__TK_CART.originalFetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      const options = args[1] || {};
      const method = (options.method || 'GET').toUpperCase();
      
      // MULTI-APP SAFETY FIX: Support plain object, Headers instance, and lowercase
      const headers = options.headers || {};
      const isInternal =
        headers['X-TK-Internal'] ||
        headers['x-tk-internal'] ||
        (typeof headers.get === 'function' && headers.get('X-TK-Internal'));
      
      // Only intercept cart mutation endpoints
      const isCartMutation = typeof url === 'string' && 
        (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js')) &&
        method !== 'GET';
      
      if (!isCartMutation || isInternal) {
        return originalFetch.apply(this, args);
      }
      
      // Generate request hash
      const requestHash = generateRequestHash(url, options.body);
      
      // MULTI-APP SAFETY FIX: Duplicate check disabled for now (always allow)
      // Re-enable later if needed with proper Response handling
      if (false && isDuplicateRequest(requestHash)) {
        // MULTI-APP SAFETY FIX: Return real Response object, not fake
        return originalFetch('/cart.js').then(r => {
          return r.clone(); // Return cloned real Response
        });
      }
      
      // Pass through to original fetch
      return originalFetch.apply(this, args);
    };
  }
  
  // Backward compatibility
  window.TKGlobalAddToCartLock = {
    acquire: function() { return true; },
    release: function() {},
    locked: false
  };
  
  // Define global openCartDrawer function immediately (before class definition)
  // This ensures it's available even if drawer isn't initialized yet
  window.openCartDrawer = function() {
    if (window.TKCartDrawer && window.TKCartDrawer.open) {
      window.TKCartDrawer.open();
    } else {
      // Retry after a short delay
      setTimeout(() => {
        if (window.TKCartDrawer && window.TKCartDrawer.open) {
          window.TKCartDrawer.open();
        }
      }, 300);
    }
  };
  
  // Global helper function to format money
  function formatMoney(cents) {
    if (typeof cents === 'undefined' || cents === null) return '$0.00';
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  // Global helper function to update cart total display
  // CLEAN: Only use Shopify's native total_price - no custom calculations
  window.updateCartTotalWithYmqAddon = function(cartData) {
    if (!cartData) return;
    
    // Use Shopify's calculated total directly
    const finalTotal = cartData.total_price || 0;
    
    // Update cart total in drawer
    const drawerTotalEl = document.querySelector('#tk-cart-drawer [data-cart-total]');
    if (drawerTotalEl) {
      drawerTotalEl.textContent = formatMoney(finalTotal);
      drawerTotalEl.setAttribute('data-cart-total', finalTotal.toString());
    }
    
    // Update cart total in main cart page
    const mainCartTotalEl = document.querySelector('.tk-main-cart-section .tk-cart-total strong .money');
    if (mainCartTotalEl) {
      mainCartTotalEl.textContent = formatMoney(finalTotal);
    }
    
    // Also update hidden cart total
    const hiddenCartTotal = document.querySelector('[data-cart-total]');
    if (hiddenCartTotal) {
      hiddenCartTotal.textContent = formatMoney(finalTotal);
      hiddenCartTotal.setAttribute('data-cart-total', finalTotal.toString());
    }
  };

  // TKCartDrawer Class
  class TKCartDrawer {
    constructor() {
      this.drawer = null;
      this.overlay = null;
      this._initialized = false;
      this._lastRefreshTime = 0;
      this.reservationTimerInterval = null;
      this.init();
    }
    init() {
      if (this._initialized) return;
      this._initialized = true;
      this.drawer = document.getElementById('tk-cart-drawer');
      this.overlay = document.getElementById('tk-cart-overlay');
      if (!this.drawer) return;
      // Event listeners
      const closeBtn = this.drawer.querySelector('[data-tk-cart-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      // Rush service handlers
      this.initRushService();
      this.initReservationTimer();
      // Quantity and remove handlers
      this.initCartHandlers();
      // Global override - early override to prevent conflicts
      window.openCartDrawer = () => {
        this.open();
      };
      // Also ensure it's available immediately
      if (!window.openCartDrawer) {
        window.openCartDrawer = () => {
          if (window.TKCartDrawer) {
            window.TKCartDrawer.open();
          } else {
            setTimeout(() => {
              if (window.TKCartDrawer) {
                window.TKCartDrawer.open();
              }
            }, 500);
          }
        };
      }
      // Override cart icon clicks (js-drawer-open-cart class)
      //this.initCartIconHandlers(); - code commentted by CSS Sales Team
      // Event listeners
      document.addEventListener('cart:open', (e) => {
        e.stopPropagation();
        this.open();
      });
      // Note: cart:updated event is handled in updateQuantity, handleAddRushService, handleRemoveRushService
      // We only listen for external cart updates (from other parts of the theme)
      document.addEventListener('cart:updated', (e) => {
        // Only refresh if this wasn't triggered by our own update
        if (!e.detail || !e.detail._tkInternalUpdate) {
          this.refresh();
        }
      });
      document.addEventListener('product-form:cart:update', () => this.refresh());
      document.addEventListener('product-form:submit:success', () => {
        setTimeout(() => this.open(), 100);
      });
      document.addEventListener('product-form:cart:navigate', () => this.refresh());
      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('active')) {
          this.close();
        }
      });
    }
    initCartIconHandlers() {
      // Handle existing cart icons
      const cartIcons = document.querySelectorAll('.js-drawer-open-cart');
      cartIcons.forEach((icon, index) => {
        icon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.open();
        });
      });
      // Use event delegation for dynamically added icons
      document.addEventListener('click', (e) => {
        const cartIcon = e.target.closest('.js-drawer-open-cart');
        if (cartIcon) {
          e.preventDefault();
          e.stopPropagation();
          this.open();
        }
      }, true);
    }
    formatReservationTime(totalSeconds) {
      const safeSeconds = Math.max(0, totalSeconds);
      const minutes = Math.floor(safeSeconds / 60);
      const seconds = safeSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}min ${seconds.toString().padStart(2, '0')}sec`;
    }
    initReservationTimer() {
      if (this.reservationTimerInterval) {
        window.clearInterval(this.reservationTimerInterval);
        this.reservationTimerInterval = null;
      }
      if (!this.drawer) return;
      const timerRoot = this.drawer.querySelector('[data-tk-reservation-timer]');
      const timerValue = this.drawer.querySelector('[data-tk-reservation-timer-value]');
      if (!timerRoot || !timerValue) return;
      const minutes = Number(timerRoot.dataset.timerMinutes || 10);
      const durationSeconds = Math.max(1, Math.round(minutes * 60));
      const storageKey = 'tk_cart_reservation_deadline';
      const now = Date.now();
      let deadline = Number(window.localStorage.getItem(storageKey) || 0);
      if (!deadline || deadline <= now) {
        deadline = now + (durationSeconds * 1000);
        window.localStorage.setItem(storageKey, String(deadline));
      }
      const updateTimer = () => {
        let remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        // Loop: when countdown hits zero, start a new cycle with the same duration
        if (remaining <= 0) {
          deadline = Date.now() + durationSeconds * 1000;
          window.localStorage.setItem(storageKey, String(deadline));
          remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        }
        timerValue.textContent = this.formatReservationTime(remaining);
      };
      updateTimer();
      this.reservationTimerInterval = window.setInterval(updateTimer, 1000);
    }
    open() {

      // Don't open drawer on cart page
      if (document.querySelector('.tk-main-cart-section') || window.location.pathname.includes('/cart')) {
        return;
      }
      // Re-query elements in case DOM changed
      if (!this.drawer) {
        this.drawer = document.getElementById('tk-cart-drawer');
      }
      if (!this.drawer) {
        // Try to find it one more time
        setTimeout(() => {
          this.drawer = document.getElementById('tk-cart-drawer');
          if (this.drawer) {
            this.open();
          }
        }, 100);
        return;
      }
      if (!this.overlay) {
        this.overlay = document.getElementById('tk-cart-overlay');
      }

      // Open drawer - use 'active' class to match CSS
      this.drawer.classList.add('active');
      document.body.classList.add('tk-cart-drawer-open');
      if (this.overlay) {
        this.overlay.classList.add('active');
      }
      document.body.style.overflow = 'hidden';
      // Set aria attributes
      this.drawer.setAttribute('aria-hidden', 'false');
      // Force reflow to ensure CSS transition works
      this.drawer.offsetHeight;

      // Initialize note handlers and load note from API when drawer opens
      const self = this;
      setTimeout(() => {
        if (self && typeof self.initCartNoteHandlers === 'function') {
          self.initCartNoteHandlers();
        }
        if (self && typeof self.loadCartNote === 'function') {
          self.loadCartNote();
        }
      }, 100);

      // ✅ Refresh cart content only if we have not refreshed in the last 2 seconds
      const now = Date.now();
      const timeSinceLastRefresh = now - this._lastRefreshTime;
      if (timeSinceLastRefresh > 2000) {
        this.refresh();
      }
    }
    close() {
      if (this.drawer) {
        this.drawer.classList.remove('active');
        this.drawer.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('tk-cart-drawer-open');
      if (this.overlay) {
        this.overlay.classList.remove('active');
      }
      document.body.style.overflow = '';
    }
    async refresh() {
      this._lastRefreshTime = Date.now();
      try {
        // Get section settings from current page (these won't change during refresh)
        const sectionDataEl = document.getElementById('tk-cart-drawer-section-data');
        let sectionSettings = null;
        if (sectionDataEl) {
          try {
            sectionSettings = JSON.parse(sectionDataEl.textContent);
          } catch (e) {
          }
        }
        // Use locale-aware URL if available
        const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? window.Shopify.routes.root
          : '/';
        // Get cart data from Shopify Cart API (with cache-busting)
        const cartUrl = `${baseUrl}cart.js?t=${Date.now()}`;
        const cartResponse = await fetch(cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!cartResponse.ok) {
          console.error('❌ Cart fetch failed:', cartResponse.status);
          throw new Error(`Failed to fetch cart data: ${cartResponse.status}`);
        }
        const cartData = await cartResponse.json();
        
        // ✅ Get section ID - öncelik sırası:
        // 1. JSON data tag
        // 2. Drawer element data attribute
        // 3. Section wrapper
        let sectionId = sectionSettings ? sectionSettings.id : null;
        
        // Fallback 1: Drawer element
        if (!sectionId && this.drawer) {
          sectionId = this.drawer.getAttribute('data-section-id');
        }
        
        // Fallback 2: Section wrapper
        if (!sectionId) {
          const sectionWrapper = document.getElementById('tk-cart-drawer-section-wrapper') || 
                                 document.querySelector('[data-section-type="tk-cart-drawer"]');
          if (sectionWrapper) {
            sectionId = sectionWrapper.getAttribute('data-section-id');
          }
        }
        
        if (!sectionId) {
          console.error('❌ Failed to resolve cart drawer section ID, aborting refresh.');
          console.error('   Debug: this.drawer?', !!this.drawer);
          console.error('   Debug: sectionSettings?', !!sectionSettings);
          return;
        }
        
        // Fetch section HTML with the correct section ID using Shopify Sections API
        const fetchUrl = `${baseUrl}?sections=${sectionId}`;
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          console.error('❌ Section fetch failed:', response.status);
          throw new Error(`Failed to refresh cart: ${response.status}`);
        }
        // Parse JSON response from Shopify Sections API
        const sectionsData = await response.json();

        // Get the HTML for our section
        let html = sectionsData[sectionId];
        if (!html) {
          // Try to find any section in the response
          const keys = Object.keys(sectionsData);
          if (keys.length > 0) {
            html = sectionsData[keys[0]];
          } else {
            console.error('❌ No section HTML found in response, aborting refresh.');
            return;
          }
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        // Find the wrapper div that contains the drawer
        const sectionWrapperInHtml = doc.getElementById('tk-cart-drawer-section-wrapper') ||
                                     doc.querySelector('[data-section-type="tk-cart-drawer"]');
        const newDrawer = sectionWrapperInHtml 
          ? sectionWrapperInHtml.querySelector('#tk-cart-drawer')
          : doc.getElementById('tk-cart-drawer');
        
        if (!newDrawer) {
          console.error('❌ Refreshed cart drawer markup not found, aborting refresh.');
          return;
        }
        if (!this.drawer) {
          console.error('❌ Existing cart drawer element is missing, aborting refresh.');
          return;
        }
        // Check section data in refreshed HTML
        const newSectionDataEl = doc.getElementById('tk-cart-drawer-section-data');
        if (newSectionDataEl) {
          try {
            const newSectionData = JSON.parse(newSectionDataEl.textContent);
          } catch (e) {
          }
        } else {
        }
        if (newDrawer && this.drawer) {
          const body = this.drawer.querySelector('#tk-cart-body');
          const footer = this.drawer.querySelector('.tk-cart-footer');
          const newBody = newDrawer.querySelector('#tk-cart-body');
          const newFooter = newDrawer.querySelector('.tk-cart-footer');
          if (body && newBody) {
            body.innerHTML = newBody.innerHTML;
            // Verify shipping bars are present and re-render if needed
            const shippingSection = body.querySelector('.tk-free-shipping-section');
            if (shippingSection) {
              // Shipping bars are automatically re-rendered with cart refresh
              // Each shipping bar (patches, blank-apparel, warrior-membership, all) is separate
            } else {
              // Shipping bars not found, might need to reload
            }
          }
          if (footer && newFooter) {
            footer.innerHTML = newFooter.innerHTML;
            // Verify rush service is present
            const rushSection = footer.querySelector('.tk-rush-production-content');
            if (rushSection) {
            } else {
            }
            
            // Update rush service visibility after footer refresh
            // Use setTimeout to ensure DOM is fully updated
            setTimeout(() => {
              this.updateRushContentVisibility(cartData);
            }, 50);
            
            // Re-initialize note handlers and reload note from API after footer content is replaced
            const self = this;
            setTimeout(() => {
              if (self && typeof self.initCartNoteHandlers === 'function') {
                self.initCartNoteHandlers();
              }
              if (self && typeof self.loadCartNote === 'function') {
                self.loadCartNote();
              }
            }, 50);
          }
          
          // Update cart count from cart API data
          const cartCountEl = this.drawer.querySelector('[data-tk-cart-count]');
          if (cartCountEl && cartData.items) {
            let realCount = 0;
            cartData.items.forEach(item => {
              realCount += item.quantity;
            });
            cartCountEl.textContent = realCount;
          }
          // Update total price with YMQ Addon prices
          if (window.updateCartTotalWithYmqAddon) {
            window.updateCartTotalWithYmqAddon(cartData);
          }
          // Update savings from cart API data
          const savingsEl = this.drawer.querySelector('[data-cart-savings]');
          const savingsRow = this.drawer.querySelector('[data-cart-savings-row]');
          if (cartData.total_discount && cartData.total_discount > 0) {
            if (savingsEl) savingsEl.textContent = '-' + this.formatMoney(cartData.total_discount);
            if (savingsRow) savingsRow.style.display = '';
          } else {
            if (savingsRow) savingsRow.style.display = 'none';
          }
          // Check if cart is empty and show empty state
          const emptyState = this.drawer.querySelector('.tk-cart-empty');
          const cartItems = this.drawer.querySelector('.tk-free-shipping-section, .tk-cart-item');
          if (emptyState) {
            if (cartData.item_count > 0 && cartItems) {
              emptyState.classList.remove('active');
            } else if (cartData.item_count === 0) {
              emptyState.classList.add('active');
            }
          }
          // Ensure rush service wrapper is visible (only if cart has items)
          // But preserve collapsed state if it was collapsed
          if (cartItems) {
            const rushSection = this.drawer.querySelector('.tk-rush-production-content');
            if (rushSection) {
              const rushWrapper = rushSection.querySelector('.tk-rush-content-wrapper');
              const expandBtn = rushSection.querySelector('[data-tk-rush-expand]');
              const closeBtn = rushSection.querySelector('[data-tk-rush-close]');
              const addNoteBtn = rushSection.querySelector('[data-tk-rush-add-note]');
              // Check if it was collapsed before refresh
              const wasCollapsed = rushSection.classList.contains('collapsed');
              if (wasCollapsed) {
                // Restore collapsed state
                if (rushWrapper) rushWrapper.style.display = 'none';
                if (expandBtn) expandBtn.style.display = 'block';
                if (closeBtn) closeBtn.style.display = 'none';
              } else {
                // Ensure it's expanded
                if (rushWrapper) {
                  rushWrapper.style.display = 'block';
                }
                if (expandBtn) expandBtn.style.display = 'none';
                if (closeBtn) closeBtn.style.display = 'block';
              }
              // Ensure note section is always visible (separate from rush content)
              const noteSection = rushSection.querySelector('.tk-rush-note-section');
              if (noteSection) {
                noteSection.style.display = 'block';
              }
              // Ensure add note button is visible
              if (addNoteBtn) {
                addNoteBtn.style.display = 'flex';
              } else {
              }
              // Check if rush product is in cart and hide/show rush-content accordingly
              const sectionDataEl = document.getElementById('tk-cart-drawer-section-data');
              if (sectionDataEl) {
                try {
                  const sectionData = JSON.parse(sectionDataEl.textContent);
                  const rushVariantId = sectionData.settings?.rush_product_variant_id;
                  if (rushVariantId && cartData.items) {
                    const rushProductInCart = cartData.items.some(item => item.variant_id == rushVariantId);
                    const rushContent = rushWrapper?.querySelector('.tk-rush-content');
                    if (rushContent) {
                      if (rushProductInCart) {
                        // Hide rush-content when rush product is in cart
                        rushContent.style.display = 'none';

                      } else {
                        // Show rush-content when rush product is not in cart
                        rushContent.style.display = '';

                      }
                    }
                  }
                } catch (e) {
                }
              }
            } else {
            }
          }
          // Re-initialize handlers after DOM update
          this.updateCartCount();
          this.initRushService();
          this.initReservationTimer();
          // Rush service visibility is controlled by Liquid template (has_blank_apparel, has_sticker, rush_product_in_cart)
          // Don't force visibility here - respect the inline style set by Liquid
          const rushSectionAfterRefresh = this.drawer.querySelector('.tk-rush-production-content');
          if (rushSectionAfterRefresh) {
            // Only make visible if Liquid didn't hide it (no inline display:none)
            const inlineDisplay = rushSectionAfterRefresh.style.display;
            if (inlineDisplay !== 'none') {
              rushSectionAfterRefresh.style.visibility = 'visible';
            }
          }
        } else {
        }
      } catch (error) {
        console.error('❌ refresh() error:', error);
      }
    }
    formatMoney(cents) {
      if (typeof cents === 'undefined' || cents === null) return '$0.00';
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    isRushProduct(cartItem) {
      // Check if cart item has the rush product data attribute
      return cartItem && cartItem.getAttribute('data-is-rush-product') === 'true';
    }
    initCartHandlers() {
      if (!this.drawer) {
        return;
      }
      
      // ✅ CRITICAL: Event handler'ları sadece bir kez bağla
      // Her refresh'te tekrar bağlanmaması için flag kontrol et
      if (this._handlersInitialized) {
        return;
      }
      this._handlersInitialized = true;
      
      // Store bound handlers to prevent double-binding
      if (!this._boundHandlers) {
        this._boundHandlers = {
          quantityChange: (e) => this.handleQuantityChange(e),
          quantityButtonClick: (e) => this.handleQuantityButtonClick(e),
          removeItem: (e) => this.handleRemoveItem(e)
        };
      }
      
      // ✅ Event delegation kullan - her eleman için ayrı listener yerine
      // Drawer üzerinde tek bir listener (DOM update'lerinde de çalışır)
      this.drawer.addEventListener('click', (e) => {
        // Quantity button click
        const qtyBtn = e.target.closest('[data-tk-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          e.stopPropagation();
          this._boundHandlers.quantityButtonClick(e);
          return;
        }
        
        // Remove button click
        const removeBtn = e.target.closest('[data-tk-remove-item]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          this._boundHandlers.removeItem(e);
          return;
        }
      }, true); // Capture phase
      
      // Quantity input change (event delegation çalışmaz, her input'a ayrı)
      this.drawer.addEventListener('change', (e) => {
        if (e.target.matches('[data-tk-qty-input]')) {
          this._boundHandlers.quantityChange(e);
        }
      });
      
      // Handlers successfully bound (using event delegation)
    }
    handleQuantityChange(e) {
      const input = e.target;
      const itemKey = input.getAttribute('data-tk-qty-input');
      const quantity = parseInt(input.value, 10);
      const minQty = parseInt(input.getAttribute('data-min-qty') || '1', 10);
      // Check if this is a rush product (quantity should be fixed at 1)
      const cartItem = input.closest('[data-cart-item-key]');
      if (cartItem && this.isRushProduct(cartItem)) {
        input.value = 1;
        return;
      }
      if (!itemKey || isNaN(quantity) || quantity < minQty) {
        input.value = minQty;
        return;
      }
      // Prevent double submission
      if (input.disabled) {
        return;
      }
      // Add loading state
      input.disabled = true;
      input.classList.add('tk-loading');
      this.updateQuantity(itemKey, quantity).finally(() => {
        input.disabled = false;
        input.classList.remove('tk-loading');
      });
    }
    handleQuantityButtonClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // ✅ CRITICAL: When using event delegation, always use e.target.closest()
      const btn = e.target.closest('[data-tk-qty-change]');
      if (!btn) {
        console.error('❌ Quantity button not found in delegated handler.');
        return;
      }
      
      // ✅ CRITICAL: Buton zaten işlem yapıyorsa, çık
      if (btn.disabled || btn.classList.contains('tk-loading')) {
        // Already processing, ignore double-click
        return;
      }
      
      // ✅ GLOBAL ADD-TO-CART LOCK kontrolü
      if (window.TKGlobalAddToCartLock && window.TKGlobalAddToCartLock.locked) {
        // Global add-to-cart lock active, skip quantity change
        return;
      }
      
      const itemKey = btn.getAttribute('data-tk-qty-change');
      const change = parseInt(btn.getAttribute('data-change') || '0', 10);
      if (!itemKey) {
        return;
      }
      
      // MULTI-APP SAFETY FIX: use scoped locks, no window[lockKey]
      const lockKey = `qty_update_lock_${itemKey}`;
      const locks = window.__TK_CART && window.__TK_CART.locks ? window.__TK_CART.locks : {};
      if (locks[lockKey]) {
        // Quantity update already in progress for this item
        return;
      }
      locks[lockKey] = true;
      
      // Check if this is a rush product (quantity should be fixed at 1)
      const cartItem = btn.closest('[data-cart-item-key]');
      if (cartItem && this.isRushProduct(cartItem)) {
        delete locks[lockKey];
        return;
      }
      
      const input = this.drawer.querySelector(`[data-tk-qty-input="${itemKey}"]`);
      if (!input) {
        delete locks[lockKey];
        return;
      }
      
      // Prevent if input is disabled (already processing)
      if (input.disabled) {
        delete locks[lockKey];
        return;
      }
      
      const currentQty = parseInt(input.value, 10) || 1;
      const minQty = parseInt(input.getAttribute('data-min-qty') || '1', 10);
      const newQty = Math.max(minQty, currentQty + change);
      
      // Add loading state with spinner (same as remove button)
      btn.disabled = true;
      btn.classList.add('tk-loading');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="tk-loading-spinner"></span>';
      input.disabled = true;
      input.classList.add('tk-loading');
      input.value = newQty;
      
      // ✅ Tüm miktar butonlarını geçici olarak disable et
      const allQtyButtons = this.drawer.querySelectorAll('[data-tk-qty-change]');
      allQtyButtons.forEach(b => b.disabled = true);
      
      this.updateQuantity(itemKey, newQty).finally(() => {
        btn.disabled = false;
        btn.classList.remove('tk-loading');
        btn.innerHTML = originalHTML;
        input.disabled = false;
        input.classList.remove('tk-loading');
        
        // MULTI-APP SAFETY FIX: release lock from scoped object
        if (window.__TK_CART && window.__TK_CART.locks) delete window.__TK_CART.locks[lockKey];
        
        // ✅ Tüm miktar butonlarını tekrar aktif et
        allQtyButtons.forEach(b => b.disabled = false);
      });
    }
    async handleRemoveItem(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // ✅ CRITICAL: When using event delegation, always use e.target.closest()
      const btn = e.target.closest('[data-tk-remove-item]');
      if (!btn) {
        console.error('❌ Remove button not found in delegated handler.');
        return;
      }
      
      const itemKey = btn.getAttribute('data-tk-remove-item');
      if (!itemKey) {
        console.error('❌ Cart item key missing on remove button.');
        return;
      }
      // Prevent double clicks
      if (btn.disabled) {
        // Remove button already disabled
        return;
      }
      
      // ✅ Ana ürünün product ID'sini bul (fee item'ları silmek için)
      const cartItem = btn.closest('[data-cart-item-key]');
      let productIdToRemove = null;
      if (cartItem) {
        const titleLink = cartItem.querySelector('.tk-item-title a[href*="/products/"]');
        if (titleLink) {
          const productUrl = titleLink.getAttribute('href');
          const match = productUrl.match(/variant=(\d+)/);
          if (match) {
            // Variant ID'den product ID'yi bulmak için cart data'yı kontrol edelim
            try {
              const cartResp = await fetch(`/cart.js?t=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
              const cartData = await cartResp.json();
              const currentItem = cartData.items.find(it => it.key === itemKey);
              if (currentItem) {
                productIdToRemove = currentItem.product_id;
              }
            } catch (err) {
              // Failed to get product ID, continue without fee removal
            }
          }
        }
      }
      
      // Add loading state
      btn.disabled = true;
      btn.classList.add('tk-loading');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="tk-loading-spinner"></span>';
      
      try {
        // Remove the item
        await this.updateQuantity(itemKey, 0);
        
        // ✅ Eğer bu normal bir ürünse, ona bağlı fee item'ları da sil (DOM'dan)
        if (productIdToRemove) {
          // DOM'dan fee item'ları bul
          const cartItems = this.drawer.querySelectorAll('[data-cart-item-key]');
          const feeItemsToRemove = [];
          
          cartItems.forEach(cartItemEl => {
            const itemKey = cartItemEl.getAttribute('data-cart-item-key');
            // DOM'dan _tkParentProductId property'sini kontrol et
            const properties = cartItemEl.querySelectorAll('.tk-item-property');
            let parentProductId = null;
            
            properties.forEach(prop => {
              const propText = prop.textContent.trim();
              if (propText.includes('_tkParentProductId')) {
                const match = propText.match(/_tkParentProductId[:\s]+(\d+)/i);
                if (match && match[1]) {
                  parentProductId = parseInt(match[1]);
                }
              }
            });
            
            if (parentProductId === productIdToRemove) {
              feeItemsToRemove.push({ key: itemKey });
            }
          });
          
          
          for (const feeItem of feeItemsToRemove) {
            await this.updateQuantity(feeItem.key, 0);
          }
        }
        
      } finally {
        btn.disabled = false;
        btn.classList.remove('tk-loading');
        btn.innerHTML = originalHTML;
      }
    }
    async updateQuantity(itemKey, quantity) {
      
      // MULTI-APP SAFETY FIX: global lock in scoped object
      const globalLockKey = `global_update_lock_${itemKey}`;
      const locks = window.__TK_CART && window.__TK_CART.locks ? window.__TK_CART.locks : {};
      if (locks[globalLockKey]) {
        return locks[globalLockKey];
      }
      
      // Prevent concurrent updates for the same item (instance level)
      const updateKey = `update_${itemKey}`;
      if (this[updateKey]) {
        return this[updateKey];
      }
      
      const updatePromise = (async () => {
        try {
          // ✅ Timestamp ile istek unique hale getir (cache bypass)
          const timestamp = Date.now();
          const cartChangeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
            ? `${window.Shopify.routes.root}cart/change.js?t=${timestamp}`
            : `/cart/change.js?t=${timestamp}`;
          
          // ✅ CRITICAL: Add internal flag to bypass fetch interceptor
          const response = await fetch(cartChangeUrl, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-TK-Internal': '1'
            },
            body: JSON.stringify({ id: itemKey, quantity: quantity })
          });
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || 'Failed to update quantity');
          }
          const cartData = await response.json();
          
          // Mark as internal update to prevent double refresh
          cartData._tkInternalUpdate = true;
          // Refresh cart drawer
          await this.refresh();
          // Dispatch cart updated event (other parts of theme can listen)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
        } catch (error) {
          console.error('❌ updateQuantity error:', error);
          throw error;
        } finally {
          delete this[updateKey];
          if (window.__TK_CART && window.__TK_CART.locks) delete window.__TK_CART.locks[globalLockKey];
        }
      })();
      
      this[updateKey] = updatePromise;
      if (window.__TK_CART && window.__TK_CART.locks) window.__TK_CART.locks[globalLockKey] = updatePromise;
      return updatePromise;
    }
    initRushService() {
      if (!this.drawer) return;
      // Store bound handlers to prevent double-binding
      if (!this._boundRushHandlers) {
        this._boundRushHandlers = {
          add: (e) => this.handleAddRushService(e),
          remove: (e) => this.handleRemoveRushService(e),
          close: (e) => this.handleCloseRushService(e),
          expand: (e) => this.handleExpandRushService(e),
          addNote: (e) => this.handleAddNoteClick(e),
          saveNote: (e) => this.handleSaveNote(e),
          cancelNote: (e) => this.handleCancelNote(e),
          editNote: (e) => this.handleEditNote(e)
        };
      }
      const addBtn = this.drawer.querySelector('[data-rush-product-id]');
      const removeBtn = this.drawer.querySelector('[data-tk-rush-remove]');
      const closeBtn = this.drawer.querySelector('[data-tk-rush-close]');
      const expandBtn = this.drawer.querySelector('[data-tk-rush-expand]');
      const addNoteBtn = this.drawer.querySelector('[data-tk-rush-add-note]');
      const saveNoteBtn = this.drawer.querySelector('[data-tk-rush-note-save]');
      const cancelNoteBtn = this.drawer.querySelector('[data-tk-rush-note-cancel]');
      const editNoteBtn = this.drawer.querySelector('[data-tk-rush-note-edit]');
      if (addBtn) {
        addBtn.removeEventListener('click', this._boundRushHandlers.add);
        addBtn.addEventListener('click', this._boundRushHandlers.add);
      }
      if (removeBtn) {
        removeBtn.removeEventListener('click', this._boundRushHandlers.remove);
        removeBtn.addEventListener('click', this._boundRushHandlers.remove);
      }
      if (closeBtn) {
        closeBtn.removeEventListener('click', this._boundRushHandlers.close);
        closeBtn.addEventListener('click', this._boundRushHandlers.close);
      }
      if (expandBtn) {
        expandBtn.removeEventListener('click', this._boundRushHandlers.expand);
        expandBtn.addEventListener('click', this._boundRushHandlers.expand);
      }
      // Add Note handlers
      if (addNoteBtn) {
        addNoteBtn.removeEventListener('click', this._boundRushHandlers.addNote);
        addNoteBtn.addEventListener('click', this._boundRushHandlers.addNote);
      } else {
      }
      if (saveNoteBtn) {
        saveNoteBtn.removeEventListener('click', this._boundRushHandlers.saveNote);
        saveNoteBtn.addEventListener('click', this._boundRushHandlers.saveNote);
      } else {
      }
      if (cancelNoteBtn) {
        cancelNoteBtn.removeEventListener('click', this._boundRushHandlers.cancelNote);
        cancelNoteBtn.addEventListener('click', this._boundRushHandlers.cancelNote);
      } else {
      }
      if (editNoteBtn) {
        editNoteBtn.removeEventListener('click', this._boundRushHandlers.editNote);
        editNoteBtn.addEventListener('click', this._boundRushHandlers.editNote);
      } else {
      }
    }
    async handleAddRushService(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const variantId = btn.getAttribute('data-rush-product-id');
      if (!variantId) return;
      
      // Check if already loading
      if (btn.classList.contains('loading')) {
        return;
      }
      
      try {
        // Check if rush product is already in cart (with cache-busting)
        const cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          const rushProductInCart = cartData.items.some(item => item.variant_id == variantId);
          if (rushProductInCart) {
            return;
          }
        }
        
        // Add loading state
        btn.classList.add('loading');
        btn.disabled = true;
        
        // Use locale-aware URL if available, otherwise fallback to default
        const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart/add.js`
          : '/cart/add.js';
        // Shopify AJAX Cart API format: items array
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-TK-Internal': '1'
          },
          body: JSON.stringify({ 
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Failed to add rush service');
        }
        const cartData = await response.json();
        
        // Mark as internal update to prevent double refresh
        cartData._tkInternalUpdate = true;
        // Refresh cart drawer
        await this.refresh();
        // Dispatch cart updated event (other parts of theme can listen)
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      } catch (error) {
        console.error('Failed to add rush service:', error);
      } finally {
        // Remove loading state
        btn.classList.remove('loading');
        btn.disabled = false;
      }
    }
    async handleRemoveRushService(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const itemKey = btn.closest('[data-tk-rush-item]')?.getAttribute('data-tk-rush-item') || 
                      btn.getAttribute('data-tk-rush-remove');
      if (!itemKey) return;
      try {
        btn.disabled = true;
        // Use locale-aware URL if available, otherwise fallback to default
        const cartChangeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart/change.js`
          : '/cart/change.js';
        const response = await fetch(cartChangeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-TK-Internal': '1'
          },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Failed to remove rush service');
        }
        const cartData = await response.json();
        // Mark as internal update to prevent double refresh
        cartData._tkInternalUpdate = true;
        // Refresh cart drawer
        await this.refresh();
        // Dispatch cart updated event (other parts of theme can listen)
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      } catch (error) {
        console.error('Failed to remove rush service:', error);
      } finally {
        btn.disabled = false;
      }
    }
    handleCloseRushService(e) {
      e.preventDefault();
      e.stopPropagation();

      const rushSection = e.currentTarget.closest('.tk-rush-production-content');
      if (rushSection) {
        const wrapper = rushSection.querySelector('.tk-rush-content-wrapper');
        const expandBtn = rushSection.querySelector('[data-tk-rush-expand]');
        const closeBtn = rushSection.querySelector('[data-tk-rush-close]');
        const noteSection = rushSection.querySelector('.tk-rush-note-section');
        // Collapse only the rush content wrapper (not the note section)
        if (wrapper) {
          wrapper.style.display = 'none';
        }
        if (expandBtn) {
          expandBtn.style.display = 'block';
        }
        if (closeBtn) {
          closeBtn.style.display = 'none';
        }
        // Ensure note section stays visible
        if (noteSection) {
          noteSection.style.display = 'block';
        }
        // Add collapsed class for CSS
        rushSection.classList.add('collapsed');
      }
    }
    handleExpandRushService(e) {
      e.preventDefault();
      e.stopPropagation();
      const rushSection = e.currentTarget.closest('.tk-rush-production-content');
      if (rushSection) {
        const wrapper = rushSection.querySelector('.tk-rush-content-wrapper');
        const expandBtn = rushSection.querySelector('[data-tk-rush-expand]');
        const closeBtn = rushSection.querySelector('[data-tk-rush-close]');
        const noteSection = rushSection.querySelector('.tk-rush-note-section');
        // Expand the content
        if (wrapper) {
          wrapper.style.display = 'block';
        }
        if (expandBtn) {
          expandBtn.style.display = 'none';
        }
        if (closeBtn) {
          closeBtn.style.display = 'block';
        }
        // Ensure note section stays visible
        if (noteSection) {
          noteSection.style.display = 'block';
        }
        // Remove collapsed class
        rushSection.classList.remove('collapsed');
      }
    }
    handleAddNoteClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const noteSection = e.currentTarget.closest('.tk-rush-note-section');
      if (noteSection) {
        const addBtn = noteSection.querySelector('[data-tk-rush-add-note]');
        const editor = noteSection.querySelector('.tk-rush-note-editor');
        const display = noteSection.querySelector('.tk-rush-note-display');
        const textarea = noteSection.querySelector('.tk-rush-note-textarea');
        if (addBtn) addBtn.style.display = 'none';
        if (editor) {
          editor.style.display = 'block';
          // Focus textarea
          if (textarea) {
            setTimeout(() => textarea.focus(), 100);
          }
        }
        if (display) display.style.display = 'none';
      } else {
      }
    }
    async handleSaveNote(e) {
      e.preventDefault();
      const noteSection = e.currentTarget.closest('.tk-rush-note-section');
      if (!noteSection) return;
      const textarea = noteSection.querySelector('.tk-rush-note-textarea');
      const noteText = textarea ? textarea.value.trim() : '';
      const addBtn = noteSection.querySelector('[data-tk-rush-add-note]');
      const editor = noteSection.querySelector('.tk-rush-note-editor');
      const display = noteSection.querySelector('.tk-rush-note-display');
      const displayText = noteSection.querySelector('.tk-rush-note-text');
      try {
        const cartUpdateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart/update.js`
          : '/cart/update.js';
        const response = await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-TK-Internal': '1'
          },
          body: JSON.stringify({ note: noteText })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Failed to save note');
        }
        const cartData = await response.json();
        // Update UI
        if (displayText) displayText.textContent = noteText || '(No note)';
        if (addBtn) addBtn.style.display = noteText ? 'none' : 'block';
        if (editor) editor.style.display = 'none';
        if (display) display.style.display = noteText ? 'block' : 'none';
        // Dispatch cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      } catch (error) {
        console.error('Failed to save note:', error);
      }
    }
    handleCancelNote(e) {
      e.preventDefault();
      const noteSection = e.currentTarget.closest('.tk-rush-note-section');
      if (noteSection) {
        const addBtn = noteSection.querySelector('[data-tk-rush-add-note]');
        const editor = noteSection.querySelector('.tk-rush-note-editor');
        const display = noteSection.querySelector('.tk-rush-note-display');
        const textarea = noteSection.querySelector('.tk-rush-note-textarea');
        if (textarea) textarea.value = '';
        if (addBtn) addBtn.style.display = 'block';
        if (editor) editor.style.display = 'none';
        if (display) display.style.display = 'none';
      }
    }
    handleEditNote(e) {
      e.preventDefault();
      const noteSection = e.currentTarget.closest('.tk-rush-note-section');
      if (noteSection) {
        const addBtn = noteSection.querySelector('[data-tk-rush-add-note]');
        const editor = noteSection.querySelector('.tk-rush-note-editor');
        const display = noteSection.querySelector('.tk-rush-note-display');
        const displayText = noteSection.querySelector('.tk-rush-note-text');
        const textarea = noteSection.querySelector('.tk-rush-note-textarea');
        if (textarea && displayText) {
          textarea.value = displayText.textContent.replace('(No note)', '').trim();
        }
        if (addBtn) addBtn.style.display = 'none';
        if (editor) editor.style.display = 'block';
        if (display) display.style.display = 'none';
      }
    }
    updateCartCount(cartData) {
      const countEl = this.drawer?.querySelector('[data-tk-cart-count]');
      if (!countEl) return;

      // If we already have fresh cart data from a previous request,
      // use it directly to avoid an extra asynchronous fetch and
      // potential race conditions with another cart.js request.
      if (cartData && Array.isArray(cartData.items)) {
        let realCount = 0;
        cartData.items.forEach(item => {
          realCount += item.quantity;
        });
        countEl.textContent = realCount;
        return;
      }

      // Fallback: fetch the cart count from the Cart API
      // (kept for backward compatibility if updateCartCount is
      // called without an argument from elsewhere)
      const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
        ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
        : `/cart.js?t=${Date.now()}`;

      fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(r => {
          if (!r.ok) throw new Error('Failed to fetch cart');
          return r.json();
        })
        .then(cart => {
          let realCount = 0;
          if (Array.isArray(cart.items)) {
            cart.items.forEach(item => {
              realCount += item.quantity;
            });
          }
          countEl.textContent = realCount;
        })
        .catch(() => {
          // Silent fail – count will be updated on next successful refresh
        });
    }
    initCartNoteHandlers() {
      // Global toggle function - accessible from inline onclick
      window.tkCartToggleNote = (toggleBtn) => {
        if (!toggleBtn) {
          return;
        }
        
        const noteSection = toggleBtn.closest('.tk-cart-note-section');
        if (!noteSection) {
          return;
        }
        
        const noteContent = noteSection.querySelector('.tk-cart-note-content');
        const toggleIcon = toggleBtn.querySelector('.tk-cart-note-toggle-icon');
        
        if (!noteContent) {
          return;
        }
        
        const isHidden = noteContent.classList.contains('tk-cart-note-hidden');
        
        if (isHidden) {
          noteContent.classList.remove('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(0deg)';
          }
          
          // Focus textarea
          setTimeout(() => {
            const textarea = noteContent.querySelector('[data-tk-cart-note-textarea]');
            if (textarea) {
              textarea.focus();
            }
          }, 150);
        } else {
          noteContent.classList.add('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(180deg)';
          }
        }
      };
      
      // Simple toggle function - uses CSS class instead of inline style
      const toggleNoteContent = (toggleBtn) => {
        if (!toggleBtn) {
          return;
        }
        
        const noteSection = toggleBtn.closest('.tk-cart-note-section');
        if (!noteSection) {
          return;
        }
        
        const noteContent = noteSection.querySelector('.tk-cart-note-content');
        const toggleIcon = toggleBtn.querySelector('.tk-cart-note-toggle-icon');
        
        if (!noteContent) {
          return;
        }
        
        const isHidden = noteContent.classList.contains('tk-cart-note-hidden');
        
        if (isHidden) {
          noteContent.classList.remove('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(0deg)';
          }
          
          if (isHidden) {
            const textarea = noteContent.querySelector('[data-tk-cart-note-textarea]');
            if (textarea) {
              setTimeout(() => {
                textarea.focus();
              }, 150);
            }
          }
        } else {
          noteContent.classList.add('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(180deg)';
          }
        }
      };
      
      // Global handler - works everywhere
      const handleNoteToggle = (e) => {
        // Ignore clicks inside note content
        if (e.target.closest('.tk-cart-note-content')) {
          return;
        }
        
        // Find toggle button
        const toggleBtn = e.target.closest('[data-tk-cart-note-toggle]');
        
        if (toggleBtn) {
          e.preventDefault();
          e.stopPropagation();
          toggleNoteContent(toggleBtn);
        }
      };
      
      // Also add a listener specifically to the drawer to catch ALL clicks
      const drawer = this.drawer || document.getElementById('tk-cart-drawer');
      if (drawer) {
        const drawerClickHandler = (e) => {
          const toggleBtn = e.target.closest('[data-tk-cart-note-toggle]');
          if (toggleBtn) {
            e.preventDefault();
            e.stopPropagation();
            if (window.tkCartToggleNote) {
              window.tkCartToggleNote(toggleBtn);
            }
          }
        };
        
        drawer.addEventListener('click', drawerClickHandler, true);
        
        // Store for cleanup
        this._drawerClickHandler = drawerClickHandler;
      }
      
      // Remove old listener
      if (this._noteToggleHandler) {
        document.removeEventListener('click', this._noteToggleHandler, true);
      }
      
      this._noteToggleHandler = handleNoteToggle;
      
      // Add to document - always works
      document.addEventListener('click', handleNoteToggle, true);
      
      // Also ensure inline onclick is set (backup method)
      const ensureInlineHandler = () => {
        const drawer = this.drawer || document.getElementById('tk-cart-drawer');
        if (drawer) {
          const toggleBtn = drawer.querySelector('[data-tk-cart-note-toggle]');
          if (toggleBtn) {
            // Always set onclick to ensure it works
            toggleBtn.onclick = (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (window.tkCartToggleNote) {
                window.tkCartToggleNote(toggleBtn);
              }
            };
          }
        }
      };
      
      // Try immediately and after delays
      ensureInlineHandler();
      setTimeout(() => {
        ensureInlineHandler();
      }, 100);
      setTimeout(() => {
        ensureInlineHandler();
      }, 500);
      setTimeout(() => {
        ensureInlineHandler();
      }, 1000);
      
      // ✅ Setup auto-save for drawer note textarea
      const drawerTextarea = this.drawer?.querySelector('[data-tk-cart-note-textarea]');
      if (drawerTextarea && !drawerTextarea._noteHandlerSetup) {
        drawerTextarea._noteHandlerSetup = true;
        
        let saveTimeout = null;
        const DEBOUNCE_DELAY = 1500;
        
        const autoSaveNote = async (noteText) => {
          try {
            const cartUpdateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
              ? `${window.Shopify.routes.root}cart/update.js`
              : '/cart/update.js';
            const response = await fetch(cartUpdateUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-TK-Internal': '1'
              },
              body: JSON.stringify({ note: noteText })
            });
            
            if (response.ok) {
              // ✅ Sync to cart page textarea
              const cartPageTextarea = document.querySelector('.tk-main-cart-section [data-tk-cart-note-textarea]');
              if (cartPageTextarea && cartPageTextarea !== drawerTextarea) {
                cartPageTextarea.value = noteText;
              }
              
              // Dispatch sync event
              document.dispatchEvent(new CustomEvent('cart:note:updated', { 
                detail: { note: noteText } 
              }));
            }
          } catch (error) {
            console.error('Failed to save note:', error);
          }
        };
        
        drawerTextarea.addEventListener('input', () => {
          if (saveTimeout) clearTimeout(saveTimeout);
          saveTimeout = setTimeout(() => {
            autoSaveNote(drawerTextarea.value.trim());
          }, DEBOUNCE_DELAY);
        });
        
        drawerTextarea.addEventListener('blur', () => {
          if (saveTimeout) clearTimeout(saveTimeout);
          autoSaveNote(drawerTextarea.value.trim());
        });
      }
    }
    /** Load cart note from API and sync to all note textareas (drawer + cart page). */
    async loadCartNote() {
      try {
        const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`;
        const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cartData = await response.json();
        const noteText = cartData.note || '';
        const allTextareas = document.querySelectorAll('[data-tk-cart-note-textarea]');
        allTextareas.forEach((ta) => {
          ta.value = noteText;
        });
      } catch (error) {
        // Silent fail
      }
    }
    updateRushContentVisibility(cartData) {
      try {
        // Get rush product variant ID from section data or button
        const rushButton = this.drawer?.querySelector('[data-rush-product-id]');
        const rushSection = this.drawer?.querySelector('.tk-rush-production-content');
        
        // If rush section doesn't exist in DOM, it means Liquid template didn't render it
        // This could be due to:
        // 1. show_rush_production is false
        // 2. rush_service_product is blank
        // 3. rush_product is blank
        // 4. has_blank_apparel is true
        // 5. rush_product_in_cart is true (but user says it's not in cart)
        if (!rushSection) {
          return;
        }
        
        if (!rushButton) {
          return;
        }
        
        const rushVariantId = rushButton.getAttribute('data-rush-product-id');
        if (!rushVariantId) {
          return;
        }
        
        // Check if rush product is in cart - compare as strings to ensure match
        const rushProductInCart = cartData.items && cartData.items.some(item => {
          const itemVariantId = String(item.variant_id);
          const rushVariantIdStr = String(rushVariantId);
          return itemVariantId === rushVariantIdStr;
        });
        
        const rushContent = this.drawer?.querySelector('.tk-rush-content');
        
        if (rushProductInCart) {
          // Hide entire rush service section when rush product is in cart
          // Use setProperty with important flag to override inline styles
          rushSection.style.setProperty('display', 'none', 'important');
          rushSection.style.setProperty('visibility', 'hidden', 'important');
        } else {
          // Show entire rush service section when rush product is not in cart
          // Remove inline display style to allow CSS to control visibility
          rushSection.style.removeProperty('display');
          rushSection.style.removeProperty('visibility');
          
          // Also ensure rush content is visible
          if (rushContent) {
            rushContent.style.removeProperty('display');
          }
        }
      } catch (error) {
      }
    }
  }
  // TKCartPage Class
  class TKCartPage {
    constructor() {
      this.init();
    }
    init() {

      // Prevent form submission on cart page for quantity/remove actions
      const cartForm = document.querySelector('#cart, .cart__form');
      if (cartForm) {
        cartForm.addEventListener('submit', (e) => {
          // Check if the submit was triggered by a quantity/remove action
          const activeElement = document.activeElement;
          const isQuantityAction = activeElement && (
            activeElement.hasAttribute('data-tk-qty-input') ||
            activeElement.hasAttribute('data-tk-qty-change') ||
            activeElement.hasAttribute('data-tk-remove-item') ||
            activeElement.closest('[data-tk-qty-change]') ||
            activeElement.closest('[data-tk-remove-item]')
          );
          // Check if checkout button was clicked - don't prevent navigation
          const isCheckoutButton = activeElement && (
            activeElement.id === 'CheckOut' ||
            activeElement.classList.contains('tk-btn-checkout') ||
            activeElement.closest('.tk-btn-checkout') ||
            activeElement.closest('#CheckOut')
          );
          if (isCheckoutButton) {
            // Don't prevent default - allow checkout navigation
            return true;
          }
          if (isQuantityAction) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true); // Use capture phase to catch early
      } else {
      }
      // Remove button click handler is handled in initCartItemHandlers()
      // No need for document-level handler that might interfere
      // Ensure checkout button works properly - prevent form interference
      // Only handle checkout button on main cart page (not in drawer)
      const checkoutBtn = document.querySelector('#CheckOut');
      if (checkoutBtn && checkoutBtn.closest('.tk-main-cart-section')) {

        // Use capture phase to catch early and prevent form interference
        checkoutBtn.addEventListener('click', (e) => {
          const href = checkoutBtn.getAttribute('href');
          // Ensure we're going to checkout, not cart
          const checkoutUrl = href && href.includes('/checkout') ? href : '/checkout';
          // Stop any event propagation that might interfere with form
          e.stopPropagation();
          e.stopImmediatePropagation();
          // Navigate immediately to checkout
          window.location.href = checkoutUrl;
          e.preventDefault();
          return false;
        }, true); // Use capture phase to catch early
      }
      // Rush service handlers - use event delegation for reliability
      document.addEventListener('click', (e) => {
        const rushBtn = e.target.closest('[data-rush-product-id]');
        if (rushBtn && rushBtn.classList.contains('tk-rush-button')) {
          // Create synthetic event with correct currentTarget
          const syntheticEvent = {
            ...e,
            currentTarget: rushBtn,
            target: e.target,
            preventDefault: () => e.preventDefault(),
            stopPropagation: () => e.stopPropagation(),
            stopImmediatePropagation: () => e.stopImmediatePropagation()
          };
          this.handleAddRushService(syntheticEvent);
        }
      }, false);
      // Also initialize rush service handlers normally
      this.initRushService();
      // Cart note handlers
      this.initCartNoteHandlers();
      // Load existing cart note
      this.loadCartNote();
      // Cart quantity and remove handlers
      this.initCartItemHandlers();
      // Update rush content visibility on initial load
      this.loadRushContentVisibility();
      // Listen for cart updates (only external updates, not our own)
      // Note: cart:updated event is handled in updateQuantity, handleAddRushService, handleRemoveRushService
      // We only listen for external cart updates (from other parts of the theme)
      document.addEventListener('cart:updated', (e) => {
        // Only refresh if this wasn't triggered by our own update
        if (!e.detail || !e.detail._tkInternalUpdate) {
          this.refreshCart();
        }
      });

    }
    async loadRushContentVisibility() {
      try {
        const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`;
        const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cartData = await response.json();
        this.updateRushContentVisibility(cartData);
        this.enforceRushProductQuantity(cartData);
      } catch (error) {
      }
    }
    async enforceRushProductQuantity(cartData) {
      try {
        const rushButton = document.querySelector('[data-rush-product-id]');
        if (!rushButton) return;
        const rushVariantId = rushButton.getAttribute('data-rush-product-id');
        if (!rushVariantId) return;
        // Find rush product in cart
        const rushItem = cartData.items.find(item => item.variant_id == rushVariantId);
        if (!rushItem) return;
        // If quantity is not 1, fix it
        if (rushItem.quantity !== 1) {
          const updateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? `${window.Shopify.routes.root}cart/change.js`
            : '/cart/change.js';
          const response = await fetch(updateUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-TK-Internal': '1'
            },
            body: JSON.stringify({
              id: rushItem.key,
              quantity: 1
            })
          });
          if (response.ok) {
            // Refresh cart to reflect the change
            await this.refreshCart();
          } else {
          }
        }
      } catch (error) {
      }
    }
    initCartItemHandlers() {

      // Store bound handlers to prevent double-binding
      if (!this._boundHandlers) {
        this._boundHandlers = {
          quantityChange: (e) => this.handleQuantityChange(e),
          quantityButtonClick: (e) => this.handleQuantityButtonClick(e),
          removeItem: (e) => this.handleRemoveItem(e)
        };
      }
      // Quantity input handlers
      const qtyInputs = document.querySelectorAll('[data-tk-qty-input]');
      qtyInputs.forEach((input, index) => {
        input.removeEventListener('change', this._boundHandlers.quantityChange);
        input.addEventListener('change', this._boundHandlers.quantityChange);

      });
      // Quantity button handlers
      const qtyButtons = document.querySelectorAll('[data-tk-qty-change]');
      qtyButtons.forEach((btn, index) => {
        btn.removeEventListener('click', this._boundHandlers.quantityButtonClick);
        btn.addEventListener('click', this._boundHandlers.quantityButtonClick);

      });
      // Remove handlers
      const removeBtns = document.querySelectorAll('[data-tk-remove-item]');
      removeBtns.forEach((btn, index) => {
        // Remove all existing listeners first
        btn.removeEventListener('click', this._boundHandlers.removeItem);
        // Add new listener with capture: false (bubble phase) to ensure it runs after other handlers
        btn.addEventListener('click', this._boundHandlers.removeItem, false);

      });

    }
    handleQuantityChange(e) {

      const input = e.target;
      const itemKey = input.getAttribute('data-tk-qty-input');
      let quantity = parseInt(input.value, 10);
      const minQty = parseInt(input.getAttribute('data-min-qty') || '1', 10);
      // Check if this is a rush product (quantity should be fixed at 1)
      const cartItem = input.closest('[data-cart-item-key]');
      const isRushProduct = cartItem && (cartItem.getAttribute('data-is-rush-product') === 'true' || input.getAttribute('data-is-rush-product') === 'true');
      
      if (isRushProduct) {
        quantity = 1;
        input.value = 1;
        // Still update to ensure it's saved as 1
        if (itemKey && !input.disabled) {
          input.disabled = true;
          input.classList.add('tk-loading');
          this.updateQuantity(itemKey, 1).finally(() => {
            input.disabled = false;
            input.classList.remove('tk-loading');
          });
        }
        return;
      }
      
      if (!itemKey || isNaN(quantity) || quantity < minQty) {
        input.value = minQty;
        return;
      }
      // Prevent double submission
      if (input.disabled) {
        return;
      }
      this.updateQuantity(itemKey, quantity);
    }
    handleQuantityButtonClick(e) {

      e.preventDefault();
      e.stopPropagation();
      const btn = e.currentTarget;
      
      // ✅ CRITICAL: If button is already processing, bail
      if (btn.disabled || btn.classList.contains('tk-loading')) {
        return;
      }
      
      // ✅ GLOBAL ADD-TO-CART LOCK check
      if (window.TKGlobalAddToCartLock && window.TKGlobalAddToCartLock.locked) {
        return;
      }
      
      const itemKey = btn.getAttribute('data-tk-qty-change');
      const change = parseInt(btn.getAttribute('data-change') || '0', 10);
      if (!itemKey) {
        return;
      }
      
      // MULTI-APP SAFETY FIX: use scoped locks
      const lockKey = `qty_update_lock_${itemKey}`;
      const locks = window.__TK_CART && window.__TK_CART.locks ? window.__TK_CART.locks : {};
      if (locks[lockKey]) {
        return;
      }
      locks[lockKey] = true;
      
      // Check if this is a rush product (quantity should be fixed at 1)
      const cartItem = btn.closest('[data-cart-item-key]');
      if (cartItem && cartItem.getAttribute('data-is-rush-product') === 'true') {
        delete locks[lockKey];
        return;
      }
      
      const input = document.querySelector(`[data-tk-qty-input="${itemKey}"]`);
      if (!input) {
        delete locks[lockKey];
        return;
      }
      
      // Prevent if input is disabled (already processing)
      if (input.disabled) {
        delete locks[lockKey];
        return;
      }
      
      const currentQty = parseInt(input.value, 10) || 1;
      const minQty = parseInt(input.getAttribute('data-min-qty') || '1', 10);
      const newQty = Math.max(minQty, currentQty + change);
      
      // Add loading state with spinner (same as remove button)
      btn.disabled = true;
      btn.classList.add('tk-loading');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="tk-loading-spinner"></span>';
      input.disabled = true;
      input.classList.add('tk-loading');
      input.value = newQty;
      
      // ✅ Temporarily disable all quantity buttons
      const allQtyButtons = document.querySelectorAll('[data-tk-qty-change]');
      allQtyButtons.forEach(b => b.disabled = true);
      
      this.updateQuantity(itemKey, newQty).finally(() => {
        btn.disabled = false;
        btn.classList.remove('tk-loading');
        btn.innerHTML = originalHTML;
        input.disabled = false;
        input.classList.remove('tk-loading');
        
        // MULTI-APP SAFETY FIX: release lock from scoped object
        if (window.__TK_CART && window.__TK_CART.locks) delete window.__TK_CART.locks[lockKey];
        
        // ✅ Tüm miktar butonlarını tekrar aktif et
        allQtyButtons.forEach(b => b.disabled = false);
      });
    }
    async handleRemoveItem(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const btn = e.currentTarget;
      const itemKey = btn.getAttribute('data-tk-remove-item');
      if (!itemKey) {
        console.error('❌ [CartPage] Item key missing!');
        return;
      }
      // Prevent double clicks
      if (btn.disabled) {
        return;
      }
      
      // ✅ Find main product ID (to remove attached fee items)
      const cartItem = btn.closest('[data-cart-item-key]');
      let productIdToRemove = null;
      if (cartItem) {
        const titleLink = cartItem.querySelector('.tk-item-title a[href*="/products/"], h3 a[href*="/products/"]');
        if (titleLink) {
          const productUrl = titleLink.getAttribute('href');
          const match = productUrl.match(/variant=(\d+)/);
          if (match) {
            try {
              const cartResp = await fetch(`/cart.js?t=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
              const cartData = await cartResp.json();
              const currentItem = cartData.items.find(it => it.key === itemKey);
              if (currentItem) {
                productIdToRemove = currentItem.product_id;
              }
            } catch (err) {
            }
          }
        }
      }
      
      // Add loading state
      btn.disabled = true;
      btn.classList.add('tk-loading');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="tk-loading-spinner"></span>';
      
      try {
        // Remove the item
        await this.updateQuantity(itemKey, 0);
        
        // ✅ If this is a normal product, also remove any attached fee items
        if (productIdToRemove) {
          const cartResp = await fetch(`/cart.js?t=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
          const cartData = await cartResp.json();
          
          // DOM'dan fee item'ları bul
          const cartItems = document.querySelectorAll('.tk-main-cart-section [data-cart-item-key]');
          const feeItemsToRemove = [];
          
          cartItems.forEach(cartItemEl => {
            const itemKey = cartItemEl.getAttribute('data-cart-item-key');
            // DOM'dan _tkParentProductId property'sini kontrol et
            const properties = cartItemEl.querySelectorAll('.prop, .tk-item-property');
            let parentProductId = null;
            
            properties.forEach(prop => {
              const propText = prop.textContent.trim();
              if (propText.includes('_tkParentProductId')) {
                const match = propText.match(/_tkParentProductId[:\s]+(\d+)/i);
                if (match && match[1]) {
                  parentProductId = parseInt(match[1]);
                }
              }
            });
            
            if (parentProductId === productIdToRemove) {
              feeItemsToRemove.push({ key: itemKey });
            }
          });
          
          for (const feeItem of feeItemsToRemove) {
            await this.updateQuantity(feeItem.key, 0);
          }
        }
      } finally {
        btn.disabled = false;
        btn.classList.remove('tk-loading');
        btn.innerHTML = originalHTML;
      }
    }
    async updateQuantity(itemKey, quantity) {
      // MULTI-APP SAFETY FIX: global lock in scoped object
      const globalLockKey = `global_update_lock_${itemKey}`;
      const locks = window.__TK_CART && window.__TK_CART.locks ? window.__TK_CART.locks : {};
      if (locks[globalLockKey]) {
        return locks[globalLockKey];
      }
      
      // Prevent concurrent updates for the same item (instance level)
      const updateKey = `update_${itemKey}`;
      if (this[updateKey]) {
        return this[updateKey];
      }
      
      const updatePromise = (async () => {
        try {
          // ✅ Add timestamp to make request unique (cache bypass)
          const timestamp = Date.now();
          const cartChangeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
            ? `${window.Shopify.routes.root}cart/change.js?t=${timestamp}`
            : `/cart/change.js?t=${timestamp}`;
          
          // ✅ CRITICAL: Add internal flag to bypass fetch interceptor
          const response = await fetch(cartChangeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-TK-Internal': '1'
            },
            body: JSON.stringify({ id: itemKey, quantity: quantity })
          });
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || 'Failed to update quantity');
          }
          const cartData = await response.json();
          
          // Mark as internal update to prevent double refresh
          cartData._tkInternalUpdate = true;
          // Update cart total with YMQ Addon prices immediately (before refresh)
          if (window.updateCartTotalWithYmqAddon) {
            window.updateCartTotalWithYmqAddon(cartData);
          }
          // Refresh cart page
          await this.refreshCart();
          // Dispatch cart updated event (other parts of theme can listen)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
        } catch (error) {
          console.error('❌ [CartPage] updateQuantity error:', error);
          throw error;
        } finally {
          delete this[updateKey];
          if (window.__TK_CART && window.__TK_CART.locks) delete window.__TK_CART.locks[globalLockKey];
        }
      })();
      
      this[updateKey] = updatePromise;
      if (window.__TK_CART && window.__TK_CART.locks) window.__TK_CART.locks[globalLockKey] = updatePromise;
      return updatePromise;
    }
    async refreshCart() {
      try {
        // Get cart data (with cache-busting)
        const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`;
        const cartResponse = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (!cartResponse.ok) {
          throw new Error(`Failed to fetch cart data: ${cartResponse.status}`);
        }
        const cartData = await cartResponse.json();
        // Get section wrapper
        const sectionWrapper = document.querySelector('.tk-main-cart-section');
        if (!sectionWrapper) {
          return;
        }
        const sectionId = sectionWrapper.getAttribute('data-section-id');
        if (!sectionId) {
          return;
        }
        // Fetch section HTML using Shopify Sections API
        const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? window.Shopify.routes.root
          : '/';
        const fetchUrl = `${baseUrl}?sections=${sectionId}`;
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`Failed to refresh cart: ${response.status}`);
        }
        const sectionsData = await response.json();
        const html = sectionsData[sectionId];
        if (!html) {
          return;
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.tk-main-cart-section');
        if (newSection && sectionWrapper) {
          // Store scroll position
          const scrollPos = window.scrollY;
          // Replace entire section content
          sectionWrapper.innerHTML = newSection.innerHTML;
          // Restore scroll position
          window.scrollTo(0, scrollPos);
          // Re-initialize all handlers after DOM update
          this.init();
          // Update rush content visibility based on cart state
          this.updateRushContentVisibility(cartData);
          // Ensure rush product quantities are exactly 1
          this.enforceRushProductQuantity(cartData);
          // Update cart total with YMQ Addon prices
          if (window.updateCartTotalWithYmqAddon) {
            window.updateCartTotalWithYmqAddon(cartData);
          }
          // Shipping bars are automatically re-rendered with section refresh
          // Each shipping bar (patches, blank-apparel, warrior-membership, all) is separate
          // They are recalculated based on current cart items in tk-main-cart-shipping.liquid
        }
      } catch (error) {
      }
    }
    updateRushContentVisibility(cartData) {
      try {
        // Get rush product variant ID from section data or button
        const rushButton = document.querySelector('[data-rush-product-id]');
        const rushSection = document.querySelector('.tk-rush-production-content');
        
        // If rush section doesn't exist in DOM, it means Liquid template didn't render it
        // This could be due to:
        // 1. show_rush_production is false
        // 2. rush_service_product is blank
        // 3. rush_product is blank
        // 4. has_blank_apparel is true
        // 5. rush_product_in_cart is true (but user says it's not in cart)
        if (!rushSection) {
          return;
        }
        
        if (!rushButton) {
          return;
        }
        
        const rushVariantId = rushButton.getAttribute('data-rush-product-id');
        if (!rushVariantId) {
          return;
        }
        
        // Check if rush product is in cart - compare as strings to ensure match
        const rushProductInCart = cartData.items && cartData.items.some(item => {
          const itemVariantId = String(item.variant_id);
          const rushVariantIdStr = String(rushVariantId);
          return itemVariantId === rushVariantIdStr;
        });
        
        const rushContent = document.querySelector('.tk-rush-content');
        
        if (rushProductInCart) {
          // Hide entire rush service section when rush product is in cart
          // Use setProperty with important flag to override inline styles
          rushSection.style.setProperty('display', 'none', 'important');
          rushSection.style.setProperty('visibility', 'hidden', 'important');
        } else {
          // Show entire rush service section when rush product is not in cart
          // Remove inline display style to allow CSS to control visibility
          rushSection.style.removeProperty('display');
          rushSection.style.removeProperty('visibility');
          
          // Also ensure rush content is visible
          if (rushContent) {
            rushContent.style.removeProperty('display');
          }
        }
      } catch (error) {
      }
    }
    formatMoney(cents) {
      if (typeof cents === 'undefined' || cents === null) return '$0.00';
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    initCartNoteHandlers() {
      // Global toggle function - accessible from inline onclick
      window.tkCartToggleNote = (toggleBtn) => {
        if (!toggleBtn) {
          return;
        }
        
        const noteSection = toggleBtn.closest('.tk-cart-note-section');
        if (!noteSection) {
          return;
        }
        
        const noteContent = noteSection.querySelector('.tk-cart-note-content');
        const toggleIcon = toggleBtn.querySelector('.tk-cart-note-toggle-icon');
        
        if (!noteContent) {
          return;
        }
        
        const isHidden = noteContent.classList.contains('tk-cart-note-hidden');
        
        if (isHidden) {
          noteContent.classList.remove('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(0deg)';
          }
          
          // Focus textarea
          setTimeout(() => {
            const textarea = noteContent.querySelector('[data-tk-cart-note-textarea]');
            if (textarea) {
              textarea.focus();
            }
          }, 150);
        } else {
          noteContent.classList.add('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(180deg)';
          }
        }
      };
      
      // Simple toggle function - uses CSS class instead of inline style
      const toggleNoteContent = (toggleBtn) => {
        if (!toggleBtn) {
          return;
        }
        
        const noteSection = toggleBtn.closest('.tk-cart-note-section');
        if (!noteSection) {
          return;
        }
        
        const noteContent = noteSection.querySelector('.tk-cart-note-content');
        const toggleIcon = toggleBtn.querySelector('.tk-cart-note-toggle-icon');
        
        if (!noteContent) {
          return;
        }
        
        const isHidden = noteContent.classList.contains('tk-cart-note-hidden');
        
        if (isHidden) {
          noteContent.classList.remove('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(0deg)';
          }
          
          if (isHidden) {
            const textarea = noteContent.querySelector('[data-tk-cart-note-textarea]');
            if (textarea) {
              setTimeout(() => {
                textarea.focus();
              }, 150);
            }
          }
        } else {
          noteContent.classList.add('tk-cart-note-hidden');
          
          if (toggleIcon) {
            toggleIcon.style.transform = 'rotate(180deg)';
          }
        }
      };
      
      // Global handler - works everywhere
      const handleNoteToggle = (e) => {
        // Ignore clicks inside note content
        if (e.target.closest('.tk-cart-note-content')) {
          return;
        }
        
        // Find toggle button
        const toggleBtn = e.target.closest('[data-tk-cart-note-toggle]');
        
        if (toggleBtn) {
          e.preventDefault();
          e.stopPropagation();
          toggleNoteContent(toggleBtn);
        }
      };
      
      // Also add a listener specifically to the drawer to catch ALL clicks
      const drawer = this.drawer || document.getElementById('tk-cart-drawer');
      if (drawer) {
        const drawerClickHandler = (e) => {
          const toggleBtn = e.target.closest('[data-tk-cart-note-toggle]');
          if (toggleBtn) {
            e.preventDefault();
            e.stopPropagation();
            if (window.tkCartToggleNote) {
              window.tkCartToggleNote(toggleBtn);
            }
          }
        };
        
        drawer.addEventListener('click', drawerClickHandler, true);
        
        // Store for cleanup
        this._drawerClickHandler = drawerClickHandler;
      }
      
      // Remove old listener
      if (this._noteToggleHandler) {
        document.removeEventListener('click', this._noteToggleHandler, true);
      }
      
      this._noteToggleHandler = handleNoteToggle;
      
      // Add to document - always works
      document.addEventListener('click', handleNoteToggle, true);
      
      // Also ensure inline onclick is set (backup method)
      const ensureInlineHandler = () => {
        const drawer = this.drawer || document.getElementById('tk-cart-drawer');
        if (drawer) {
          const toggleBtn = drawer.querySelector('[data-tk-cart-note-toggle]');
          if (toggleBtn) {
            // Always set onclick to ensure it works
            toggleBtn.onclick = (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (window.tkCartToggleNote) {
                window.tkCartToggleNote(toggleBtn);
              }
            };
          }
        }
      };
      
      // Try immediately and after delays
      ensureInlineHandler();
      setTimeout(() => {
        ensureInlineHandler();
      }, 100);
      setTimeout(() => {
        ensureInlineHandler();
      }, 500);
      setTimeout(() => {
        ensureInlineHandler();
      }, 1000);
      
      const textarea = document.querySelector('[data-tk-cart-note-textarea]');
      if (!textarea) return;
      
      // Debounce timer for auto-save
      let saveTimeout = null;
      const DEBOUNCE_DELAY = 1500; // 1.5 seconds after user stops typing
      
      // Auto-save function
      const autoSaveNote = async (noteText) => {
        const statusEl = document.getElementById('tk-cart-note-status');
        if (statusEl) {
          statusEl.textContent = 'Saving...';
          statusEl.style.color = '#666';
        }
        
        try {
          const cartUpdateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
            ? `${window.Shopify.routes.root}cart/update.js`
            : '/cart/update.js';
          const response = await fetch(cartUpdateUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-TK-Internal': '1'
            },
            body: JSON.stringify({ note: noteText })
          });
          
          if (!response.ok) {
            throw new Error('Failed to save note');
          }
          
          // ✅ Sync note to all textareas (drawer and cart page)
          const allTextareas = document.querySelectorAll('[data-tk-cart-note-textarea]');
          allTextareas.forEach(ta => {
            if (ta !== textarea) {
              ta.value = noteText;
            }
          });
          
          // Show success status
          if (statusEl) {
            statusEl.textContent = 'Saved';
            statusEl.style.color = '#28a745';
            setTimeout(() => {
              statusEl.textContent = '';
            }, 2000);
          }
          
          // ✅ Dispatch custom event for note sync
          document.dispatchEvent(new CustomEvent('cart:note:updated', { 
            detail: { note: noteText } 
          }));
        } catch (error) {
          if (statusEl) {
            statusEl.textContent = 'Error saving';
            statusEl.style.color = '#dc3545';
            setTimeout(() => {
              statusEl.textContent = '';
            }, 3000);
          }
        }
      };
      
      // Listen for input changes
      textarea.addEventListener('input', () => {
        const noteText = textarea.value.trim();
        
        // Clear existing timeout
        if (saveTimeout) {
          clearTimeout(saveTimeout);
        }
        
        // Set new timeout for auto-save
        saveTimeout = setTimeout(() => {
          autoSaveNote(noteText);
        }, DEBOUNCE_DELAY);
      });
      
      // Also save on blur (when user leaves the textarea)
      textarea.addEventListener('blur', () => {
        if (saveTimeout) {
          clearTimeout(saveTimeout);
        }
        autoSaveNote(textarea.value.trim());
      });
      
      // ✅ Listen for note updates from other textareas (drawer <-> cart page sync)
      document.addEventListener('cart:note:updated', (e) => {
        if (e.detail && e.detail.note !== undefined) {
          const allTextareas = document.querySelectorAll('[data-tk-cart-note-textarea]');
          allTextareas.forEach(ta => {
            ta.value = e.detail.note;
          });
        }
      });
    }
    async loadCartNote() {
      try {
        const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`;
        const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cartData = await response.json();
        const noteText = cartData.note || '';
        const allTextareas = document.querySelectorAll('[data-tk-cart-note-textarea]');
        allTextareas.forEach((ta) => {
          ta.value = noteText;
        });
      } catch (error) {
        // Silent fail
      }
    }
    initRushService() {

      // Store bound handlers to prevent double-binding
      if (!this._boundRushHandlers) {
        this._boundRushHandlers = {
          add: (e) => this.handleAddRushService(e),
          remove: (e) => this.handleRemoveRushService(e)
        };
      }
      const addBtn = document.querySelector('[data-rush-product-id]');
      const removeBtn = document.querySelector('[data-tk-rush-remove]');
      if (addBtn) {
        // Remove all existing listeners first
        addBtn.removeEventListener('click', this._boundRushHandlers.add);
        // Add handler with capture: false to ensure it runs in bubble phase
        addBtn.addEventListener('click', this._boundRushHandlers.add, false);

        // Test: Add a direct click handler to verify button is clickable
        addBtn.addEventListener('click', (e) => {
        }, false);
      } else {
      }
      if (removeBtn) {
        removeBtn.removeEventListener('click', this._boundRushHandlers.remove);
        removeBtn.addEventListener('click', this._boundRushHandlers.remove);

      }

    }
    async handleAddRushService(e) {

      e.preventDefault();
      e.stopPropagation();
      // Get button - could be currentTarget (direct click) or closest (event delegation)
      const btn = e.currentTarget && e.currentTarget.hasAttribute('data-rush-product-id') 
        ? e.currentTarget 
        : e.target.closest('[data-rush-product-id]');
      if (!btn) {
        return;
      }
      const variantId = btn.getAttribute('data-rush-product-id');
      if (!variantId) {
        return;
      }
      try {
        // Check if rush product is already in cart (with cache-busting)
        const cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
          : `/cart.js?t=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          const rushProductInCart = cartData.items.some(item => item.variant_id == variantId);
          if (rushProductInCart) {
            return;
          }
        }
        btn.disabled = true;
        // Use locale-aware URL if available, otherwise fallback to default
        const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart/add.js`
          : '/cart/add.js';
        // Shopify AJAX Cart API format: items array
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-TK-Internal': '1'
          },
          body: JSON.stringify({ 
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Failed to add rush service');
        }
        const cartData = await response.json();
        // Ensure rush product quantity is exactly 1
        const rushItem = cartData.items.find(item => item.variant_id == variantId);
        if (rushItem && rushItem.quantity !== 1) {
          // Update quantity to 1
          const updateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? `${window.Shopify.routes.root}cart/change.js`
            : '/cart/change.js';
          await fetch(updateUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-TK-Internal': '1'
            },
            body: JSON.stringify({
              id: rushItem.key,
              quantity: 1
            })
          });
        }
        // Mark as internal update to prevent double refresh
        cartData._tkInternalUpdate = true;
        // Refresh cart page
        await this.refreshCart();
        // Dispatch cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      } catch (error) {
        console.error('Failed to add rush service:', error);
      } finally {
        btn.disabled = false;
      }
    }
    async handleRemoveRushService(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const itemKey = btn.closest('[data-tk-rush-item]')?.getAttribute('data-tk-rush-item') || 
                      btn.getAttribute('data-tk-rush-remove');
      if (!itemKey) return;
      try {
        btn.disabled = true;
        // Use locale-aware URL if available, otherwise fallback to default
        const cartChangeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
          ? `${window.Shopify.routes.root}cart/change.js`
          : '/cart/change.js';
        const response = await fetch(cartChangeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-TK-Internal': '1'
          },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Failed to remove rush service');
        }
        const cartData = await response.json();
        // Mark as internal update to prevent double refresh
        cartData._tkInternalUpdate = true;
        // Refresh cart page
        await this.refreshCart();
        // Dispatch cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      } catch (error) {
        console.error('Failed to remove rush service:', error);
      } finally {
        btn.disabled = false;
      }
    }
  }
  // Initialize function
  function initTKCart() {
    // Initialize Cart Drawer
    const drawerElement = document.getElementById('tk-cart-drawer');
    if (drawerElement) {
      if (!window.TKCartDrawer) {
        window.TKCartDrawer = new TKCartDrawer();
      } else {
      }
    } else {
    }
    // Initialize Cart Page
    const cartPageElement = document.querySelector('.tk-main-cart-section');
    if (cartPageElement || window.location.pathname.includes('/cart')) {
      if (!window.TKCartPage) {
        window.TKCartPage = new TKCartPage();
      } else {
      }
    } else {
    }
    // Prevent Customily conflicts
    if (typeof window.CustomilyCartHandler !== 'undefined') {
      const originalAddToCart = window.CustomilyCartHandler.addToCart;
      if (originalAddToCart && !window.CustomilyCartHandler._tkOverridden) {
        window.CustomilyCartHandler._tkOverridden = true;
        window.CustomilyCartHandler.addToCart = function(...args) {
          const result = originalAddToCart.apply(this, args);
          setTimeout(() => {
            if (window.TKCartDrawer) {
              window.TKCartDrawer.refresh();
              window.TKCartDrawer.open();
            }
          }, 100);
          return result;
        };
      }
    }
  }
  // Multiple initialization strategies to ensure drawer works
  function tryInit() {
    const drawerElement = document.getElementById('tk-cart-drawer');
    if (drawerElement) {
      initTKCart();
      return true;
    }
    return false;
  }
  // Strategy 1: If DOM is already ready
  if (document.readyState !== 'loading') {
    if (!tryInit()) {
    }
  }
  // Strategy 2: Wait for DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    if (!tryInit()) {
    }
  });
  // Strategy 3: Wait for full page load
  window.addEventListener('load', () => {
    if (!window.TKCartDrawer) {
      if (tryInit()) {
      }
    }
  });
  // Strategy 4: MutationObserver to catch dynamically added drawer
  // MULTI-APP SAFETY FIX: disconnect immediately after drawer found to prevent memory leak
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function() {
      if (!window.TKCartDrawer && document.getElementById('tk-cart-drawer')) {
        tryInit();
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Share Cart Function
  window.shareCart = async function() {
    try {
      // Get cart data (with cache-busting)
      const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
        ? `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
        : `/cart.js?t=${Date.now()}`;
      const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
      
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }
      
      const cartData = await response.json();
      
      // Check if cart is empty
      if (!cartData.items || cartData.items.length === 0) {
        return;
      }
      
      // Get cart token from cookies
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      }
      
      const cartToken = getCookie('cart');
      
      // Create shareable cart URL
      let shareableUrl;
      if (cartToken) {
        // Use cart token for shareable link
        shareableUrl = `${window.location.origin}/cart?token=${cartToken}`;
      } else {
        // Fallback: regular cart URL
        shareableUrl = `${window.location.origin}/cart`;
      }
      
      // Try Web Share API first (mobile)
      if (navigator.share) {
        try {
          await navigator.share({
            title: 'My Shopping Cart',
            text: 'Check out my cart!',
            url: shareableUrl
          });
          return;
        } catch (err) {
          // User cancelled or error, fall through to clipboard
        }
      }
      
      // Fallback: Copy to clipboard
      try {
        await navigator.clipboard.writeText(shareableUrl);
      } catch (err) {
        // Fallback: Show URL in prompt
        prompt('Copy this cart link:', shareableUrl);
      }
    } catch (error) {
      console.error('Failed to share cart:', error);
    }
  };
})();
